"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockMultiplierRegistryFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_defaultMultiplier",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "defaultMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
        ],
        name: "getMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "_ids",
                type: "uint256[]",
            },
        ],
        name: "getMultipliers",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_newMultiplier",
                type: "uint256",
            },
        ],
        name: "setDefaultMultiplier",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5060405161035238038061035283398101604081905261002f91610037565b60005561004f565b600060208284031215610048578081fd5b5051919050565b6102f48061005e6000396000f3fe608060405234801561001057600080fd5b506004361061004b5760003560e01c80626be98214610050578063909e336314610079578063adf8252d1461008e578063e4891825146100b1575b600080fd5b61006361005e366004610166565b6100ba565b604051610070919061023d565b60405180910390f35b61008c610087366004610225565b600055565b005b6100a361009c366004610225565b5060005490565b604051908152602001610070565b6100a360005481565b6060600082516001600160401b038111156100e557634e487b7160e01b600052604160045260246000fd5b60405190808252806020026020018201604052801561010e578160200160208202803683370190505b50835190915060005b8181101561015d5760005483828151811061014257634e487b7160e01b600052603260045260246000fd5b602090810291909101015261015681610281565b9050610117565b50909392505050565b60006020808385031215610178578182fd5b82356001600160401b038082111561018e578384fd5b818501915085601f8301126101a1578384fd5b8135818111156101b3576101b36102a8565b8060051b604051601f19603f830116810181811085821117156101d8576101d86102a8565b604052828152858101935084860182860187018a10156101f6578788fd5b8795505b838610156102185780358552600195909501949386019386016101fa565b5098975050505050505050565b600060208284031215610236578081fd5b5035919050565b6020808252825182820181905260009190848201906040850190845b8181101561027557835183529284019291840191600101610259565b50909695505050505050565b60006000198214156102a157634e487b7160e01b81526011600452602481fd5b5060010190565b634e487b7160e01b600052604160045260246000fdfea264697066735822122081deb821c171ee01506d8ede99562c5a071b4fae69f8214790077dbc6f7cd7bc64736f6c63430008030033";
class MockMultiplierRegistryFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_defaultMultiplier, overrides) {
        return super.deploy(_defaultMultiplier, overrides || {});
    }
    getDeployTransaction(_defaultMultiplier, overrides) {
        return super.getDeployTransaction(_defaultMultiplier, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockMultiplierRegistryFactory = MockMultiplierRegistryFactory;
MockMultiplierRegistryFactory.bytecode = _bytecode;
MockMultiplierRegistryFactory.abi = _abi;
//# sourceMappingURL=MockMultiplierRegistryFactory.js.map